import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { CatalogComponent } from './catalog/catalog.component';
import { CategoryListComponent } from './catalog/category/category-list/category-list.component';
import { ProductDetailComponent } from './catalog/product/product-detail/product-detail.component';
import { ProductFormComponent } from './catalog/product/product-form/product-form.component';
import { ProductListComponent } from './catalog/product/product-list/product-list.component';
import { GlobalService } from './api/global.service';
import { NotesComponent } from './notes/notes.component';
import { LoginComponent } from './auth/login/login.component';
import { AdminComponent } from './admin/admin.component';
import { BranchofficeListComponent } from './admin/branchoffice/branchoffice-list/branchoffice-list.component';
import { AuthGuard } from './guards/auth.guard';
import { MainSysComponent } from './main-sys/main-sys.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageNotfoundComponent } from './errors/page-notfound/page-notfound.component';
import { CategoryFormComponent } from './catalog/category/category-form/category-form.component';
import { CitietouristicListComponent } from './tourism/citietouristic/citietouristic-list/citietouristic-list.component';
import { CitietouristicFormComponent } from './tourism/citietouristic/citietouristic-form/citietouristic-form.component';
import { HotelListComponent } from './tourism/hotel/hotel-list/hotel-list.component';
import { HotelFormComponent } from './tourism/hotel/hotel-form/hotel-form.component';
import { HotelGalleryImgComponent } from './tourism/hotel/hotel-gallery-img/hotel-gallery-img.component';
import { HotelGalleryVideoComponent } from './tourism/hotel/hotel-gallery-video/hotel-gallery-video.component';
import { TourListComponent } from './tourism/tour/tour-list/tour-list.component';
import { TourFormComponent } from './tourism/tour/tour-form/tour-form.component';
import { TourGalleryImgComponent } from './tourism/tour/tour-gallery-img/tour-gallery-img.component';
import { TourGalleryVideoComponent } from './tourism/tour/tour-gallery-video/tour-gallery-video.component';
import { PackagetourListComponent } from './tourism/packagetour/packagetour-list/packagetour-list.component';
import { PackagetourFormComponent } from './tourism/packagetour/packagetour-form/packagetour-form.component';
import { PackagetourGalleryImgComponent } from './tourism/packagetour/packagetour-gallery-img/packagetour-gallery-img.component';
import { PackagetourGalleryVideoComponent } from './tourism/packagetour/packagetour-gallery-video/packagetour-gallery-video.component';
import { SalesListComponent } from './sale/sales/sales-list/sales-list.component';
import { SalesFormComponent } from './sale/sales/sales-form/sales-form.component';
import { ClientListComponent } from './sale/client/client-list/client-list.component';
import { ClientFormComponent } from './sale/client/client-form/client-form.component';
import { BookingsListComponent } from './booking/bookings/bookings-list/bookings-list.component';
import { BookingsFormComponent } from './booking/bookings/bookings-form/bookings-form.component';
import { BookingComponent } from './booking/booking.component';
import { BookingsDetailComponent } from './booking/bookings/bookings-detail/bookings-detail.component';
import { MoneyComponent } from './money/money.component';
import { OpeningListComponent } from './money/opening/opening-list/opening-list.component';
import { IncomeListComponent } from './money/income/income-list/income-list.component';
import { IncomeFormComponent } from './money/income/income-form/income-form.component';
import { ExpenseListComponent } from './money/expense/expense-list/expense-list.component';
import { ExpenseFormComponent } from './money/expense/expense-form/expense-form.component';
import { PurchaseComponent } from './purchase/purchase.component';
import { ProviderListComponent } from './purchase/provider/provider-list/provider-list.component';
import { ProviderFormComponent } from './purchase/provider/provider-form/provider-form.component';
import { BrandListComponent } from './catalog/brand/brand-list/brand-list.component';
import { BrandFormComponent } from './catalog/brand/brand-form/brand-form.component';
import { ServiceListComponent } from './catalog/service/service-list/service-list.component';
import { ServiceFormComponent } from './catalog/service/service-form/service-form.component';
import { LineListComponent } from './catalog/line/line-list/line-list.component';
import { LineFormComponent } from './catalog/line/line-form/line-form.component';
import { BranchofficeGuard } from './guards/branchoffice.guard';
import { SaleComponent } from './sale/sale.component';
import { SalesDetailComponent } from './sale/sales/sales-detail/sales-detail.component';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { EntryListComponent } from './warehouse/entry/entry-list/entry-list.component';
import { EntryFormComponent } from './warehouse/entry/entry-form/entry-form.component';
import { OutputListComponent } from './warehouse/output/output-list/output-list.component';
import { OutputFormComponent } from './warehouse/output/output-form/output-form.component';
import { StockgeneralListComponent } from './warehouse/stockgeneral/stockgeneral-list/stockgeneral-list.component';
import { EntryDetailComponent } from './warehouse/entry/entry-detail/entry-detail.component';
import { OutputDetailComponent } from './warehouse/output/output-detail/output-detail.component';
import { DepartureComponent } from './departure/departure.component';
import { ScheduleListComponent } from './departure/schedule/schedule-list/schedule-list.component';
import { GroupListComponent } from './departure/group/group-list/group-list.component';
import { GroupFormComponent } from './departure/group/group-form/group-form.component';
import { CollaboratorComponent } from './collaborator/collaborator.component';
import { CollaboratorsListComponent } from './collaborator/collaborators/collaborators-list/collaborators-list.component';
import { CollaboratorsFormComponent } from './collaborator/collaborators/collaborators-form/collaborators-form.component';
import { PartnersListComponent } from './collaborator/partners/partners-list/partners-list.component';
import { PartnersFormComponent } from './collaborator/partners/partners-form/partners-form.component';
import { FinanceComponent } from './finance/finance.component';
import { BankListComponent } from './finance/bank/bank-list/bank-list.component';
import { BankFormComponent } from './finance/bank/bank-form/bank-form.component';
import { AccountbankListComponent } from './finance/accountbank/accountbank-list/accountbank-list.component';
import { AccountbankFormComponent } from './finance/accountbank/accountbank-form/accountbank-form.component';
import { TransportListComponent } from './tourism/transport/transport-list/transport-list.component';
import { TransportFormComponent } from './tourism/transport/transport-form/transport-form.component';
import { GuidesListComponent } from './tourism/guides/guides-list/guides-list.component';
import { GuidesFormComponent } from './tourism/guides/guides-form/guides-form.component';
import { AgenciesListComponent } from './tourism/agencies/agencies-list/agencies-list.component';
import { AgenciesFormComponent } from './tourism/agencies/agencies-form/agencies-form.component';
import { GroupDetailComponent } from './departure/group/group-detail/group-detail.component';
import { TransfersListComponent } from './booking/transfers/transfers-list/transfers-list.component';
import { TransfersFormComponent } from './booking/transfers/transfers-form/transfers-form.component';
import { TransfersDetailComponent } from './booking/transfers/transfers-detail/transfers-detail.component';
import { ReceivedsListComponent } from './booking/receiveds/receiveds-list/receiveds-list.component';
import { ReceivedsFormComponent } from './booking/receiveds/receiveds-form/receiveds-form.component';
import { ReceivedsDetailComponent } from './booking/receiveds/receiveds-detail/receiveds-detail.component';
import { ArrivalsListComponent } from './booking/arrivals/arrivals-list/arrivals-list.component';
import { ReportComponent } from './report/report.component';
import { ReportListComponent } from './report/report-list/report-list.component';
import { BlockshotelComponent } from './report/blockshotel/blockshotel.component';
import { BlockshotelFormComponent } from './report/blockshotel/blockshotel-form/blockshotel-form.component';
import { BlockshotelDetailComponent } from './report/blockshotel/blockshotel-detail/blockshotel-detail.component';
import { BlocksagencyComponent } from './report/blocksagency/blocksagency.component';
import { BlocksagencyFormComponent } from './report/blocksagency/blocksagency-form/blocksagency-form.component';
import { BlocksagencyDetailComponent } from './report/blocksagency/blocksagency-detail/blocksagency-detail.component';
import { ScheduleReportComponent } from './report/departure/schedule-report/schedule-report.component';
import { GroupReportComponent } from './report/departure/group-report/group-report.component';
import { CotizationListComponent } from './tourism/cotization/cotization-list/cotization-list.component';
import { CotizationFormComponent } from './tourism/cotization/cotization-form/cotization-form.component';
import { HistoryboxListComponent } from './money/historybox/historybox-list/historybox-list.component';
import { BillingComponent } from './billing/billing.component';
import { VoucherListComponent } from './billing/voucher/voucher-list/voucher-list.component';
import { SummaryAdviserComponent } from './report/bookings/summary-adviser/summary-adviser.component';
import { OfferListComponent } from './tourism/offer/offer-list/offer-list.component';
import { OfferFormComponent } from './tourism/offer/offer-form/offer-form.component';
import { HistoryboxDetailComponent } from './money/historybox/historybox-detail/historybox-detail.component';
import { GroupReportBalanceComponent } from './report/departure/group-report/group-report-balance/group-report-balance.component';
import { FlightComponent } from './flight/flight.component';
import { AirlinesListComponent } from './flight/airlines/airlines-list/airlines-list.component';
import { AirlinesFormComponent } from './flight/airlines/airlines-form/airlines-form.component';
import { FlightsFormComponent } from './flight/flights/flights-form/flights-form.component';
import { FlightsListComponent } from './flight/flights/flights-list/flights-list.component';
import { BookingflightsListComponent } from './flight/bookingflights/bookingflights-list/bookingflights-list.component';
import { BookingflightsFormComponent } from './flight/bookingflights/bookingflights-form/bookingflights-form.component';
import { BookingflightsDetailComponent } from './flight/bookingflights/bookingflights-detail/bookingflights-detail.component';
import { VoucherFormComponent } from './billing/voucher/voucher-form/voucher-form.component';
import { HospitalityComponent } from './hospitality/hospitality.component';
import { RoomtypeListComponent } from './hospitality/roomtype/roomtype-list/roomtype-list.component';
import { RoomtypeFormComponent } from './hospitality/roomtype/roomtype-form/roomtype-form.component';
import { CategoryfoodListComponent } from './restaurant/categoryfood/categoryfood-list/categoryfood-list.component';
import { CategoryfoodFormComponent } from './restaurant/categoryfood/categoryfood-form/categoryfood-form.component';
import { FoodsListComponent } from './restaurant/foods/foods-list/foods-list.component';
import { FoodsFormComponent } from './restaurant/foods/foods-form/foods-form.component';
import { PostsListComponent } from './blog/posts/posts-list/posts-list.component';
import { PostsFormComponent } from './blog/posts/posts-form/posts-form.component';
import { BlogcategoryListComponent } from './blog/blogcategory/blogcategory-list/blogcategory-list.component';
import { BlogcategoryFormComponent } from './blog/blogcategory/blogcategory-form/blogcategory-form.component';
import { AuthorListComponent } from './blog/author/author-list/author-list.component';
import { AuthorFormComponent } from './blog/author/author-form/author-form.component';
import { BlogComponent } from './blog/blog.component';
import { RestaurantComponent } from './restaurant/restaurant.component';
import { GuideReportComponent } from './report/departure/guide-report/guide-report.component';
import { TransportReportComponent } from './report/departure/transport-report/transport-report.component';
import { BedroomListComponent } from './hospitality/bedroom/bedroom-list/bedroom-list.component';
import { BedroomFormComponent } from './hospitality/bedroom/bedroom-form/bedroom-form.component';
import { RatesListComponent } from './hospitality/rates/rates-list/rates-list.component';
import { RatesFormComponent } from './hospitality/rates/rates-form/rates-form.component';
import { RatesPricesComponent } from './hospitality/rates/rates-prices/rates-prices.component';
import { AgreementsListComponent } from './collaborator/agreements/agreements-list/agreements-list.component';
import { AgreementsFormComponent } from './collaborator/agreements/agreements-form/agreements-form.component';
import { HotelbookingComponent } from './hotelbooking/hotelbooking.component';
import { HotelbookingsListComponent } from './hotelbooking/hotelbookings/hotelbookings-list/hotelbookings-list.component';
import { HotelbookingsFormComponent } from './hotelbooking/hotelbookings/hotelbookings-form/hotelbookings-form.component';
import { ProformaListComponent } from './sale/proforma/proforma-list/proforma-list.component';
import { ProformaFormComponent } from './sale/proforma/proforma-form/proforma-form.component';
import { HotelplaningComponent } from './hotelbooking/hotelplaning/hotelplaning.component';
import { HoteltransfersListComponent } from './hotelbooking/hoteltransfers/hoteltransfers-list/hoteltransfers-list.component';
import { HotelbookingsDetailComponent } from './hotelbooking/hotelbookings/hotelbookings-detail/hotelbookings-detail.component';
import { ScheduleOpenListComponent } from './departure/schedule/schedule-open-list/schedule-open-list.component';
import { VouchersReportComponent } from './report/billing/vouchers-report/vouchers-report.component';
import { LoungesListComponent } from './restaurant/lounges/lounges-list/lounges-list.component';
import { LoungesFormComponent } from './restaurant/lounges/lounges-form/lounges-form.component';
import { LoungesTablesComponent } from './restaurant/lounges/lounges-tables/lounges-tables.component';
import { UserOtpComponent } from './auth/user-otp/user-otp.component';
import { EnterpriseComponent } from './admin/enterprise/enterprise.component';
import { CompanyInformationComponent } from './admin/enterprise/company/company-information/company-information.component';
import { EmployeesListComponent } from './admin/enterprise/employees/employees-list/employees-list.component';
import { EmployeesFormComponent } from './admin/enterprise/employees/employees-form/employees-form.component';
import { JobsListComponent } from './admin/enterprise/jobs/jobs-list/jobs-list.component';
import { JobsFormComponent } from './admin/enterprise/jobs/jobs-form/jobs-form.component';
import { UsersListComponent } from './admin/enterprise/users/users-list/users-list.component';
import { UsersFormComponent } from './admin/enterprise/users/users-form/users-form.component';

const currentUrl = window.location.href; // Get the current URL
const urlSegments = currentUrl.split('/'); // Split the URL into segments
const validateUrl = currentUrl.split('/#');
if(validateUrl.length == 1){
  history.pushState({}, "", "/#/"); 
  location.reload();
}

let valSlug = urlSegments[4]; // Extract the desired segment
if (valSlug == 'admin') {
  valSlug = 'slug';
}

const routes: Routes = [
  { path: "", redirectTo: '/admin/sucursales', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'verify-otp', component: UserOtpComponent, pathMatch: 'full' },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {path: 'sucursales', component: BranchofficeListComponent, title: 'Sucursales' },
      {
        path: "empresa",
        component: EnterpriseComponent,
        children: [
         // ======= information
         { path: "informacion", component: CompanyInformationComponent, title: "Empresa", data: { module: "informationcompany" }},
         // ======= employees
         { path: "empleados/lista", component: EmployeesListComponent, data: { module: "employees" }, title: 'Empleados' },
         { path: "empleados/nuevo", component: EmployeesFormComponent, data: { module: "employees" }, title: 'Nueva empleado'},
         { path: "empleados/editar/:id", component: EmployeesFormComponent, data: { module: "employees" }, title: 'Editar empleado'},
          // ======= jobs
         { path: "puestostrabajo/lista", component: JobsListComponent, data: { module: "jobs" }, title: 'Puestos trabajo' },
         { path: "puestostrabajo/nuevo", component: JobsFormComponent, data: { module: "jobs" }, title: 'Nueva puesto trabajo'},
         { path: "puestostrabajo/editar/:id", component: JobsFormComponent, data: { module: "jobs" }, title: 'Editar puesto trabajo'},
         // ======= users
         { path: "usuarios/lista", component: UsersListComponent, data: { module: "users" }, title: 'Usuarios' },
         { path: "usuarios/nuevo", component: UsersFormComponent, data: { module: "users" }, title: 'Nueva usuario'},
         { path: "usuarios/editar/:id", component: UsersFormComponent, data: { module: "users" }, title: 'Editar usuario'},
         
        ]
      },
    ]
  },
  {
    path: valSlug,
    component: MainSysComponent,
    canActivate: [AuthGuard, BranchofficeGuard],
    data: { root_sys: 'root_sys' },
    children: [
      { path: "dashboard", component: DashboardComponent, title: 'Dashboard', data: { module: "dashboard"}},
      {
        path: "almacen",
        component: WarehouseComponent,
        children: [
         // ======= entry
         { path: "entradas/lista", component: EntryListComponent, title: "Entradas", data: { module: "entry" }},
         { path: "entradas/nuevo", component: EntryFormComponent, title: "Nueva entrada", data: { module: "entry" }},
         { path: "entradas/detalle/:id", component: EntryDetailComponent, title: "Detalle entrada", data: { module: "entry" }},
         // ======= output
         { path: "salidas/lista", component: OutputListComponent, title: "Salidas", data: { module: "output" }},
         { path: "salidas/nuevo", component: OutputFormComponent, title: "Nueva salida", data: { module: "output" }},
         { path: "salidas/detalle/:id", component: OutputDetailComponent, title: "Detalle salida", data: { module: "output" }},
        
         // ======= stockgeneral
         { path: "stockgeneral/lista", component: StockgeneralListComponent, title: "Salidas", data: { module: "entry" }},
         
        ]
      },

      {
        path: "catalogo",
        component: CatalogComponent,
        children: [
          // ======= product
          { path: "productos/lista", component: ProductListComponent, title: 'Productos',data: { module: "product" }},
          { path: "productos/nuevo", component: ProductFormComponent, data: { module: "product" }, title: 'Nueva producto'},
          { path: "productos/editar/:id", component: ProductFormComponent, data: { module: "product" }, title: 'Editar producto'},
          
          // ======= service
          { path: "servicios/lista", component: ServiceListComponent, title: 'Servicios', data: { module: "service"}},
          { path: "servicios/nuevo", component: ServiceFormComponent, data: { module: "service" }, title: 'Nueva servicio'},
          { path: "servicios/editar/:id", component: ServiceFormComponent, data: { module: "service" }, title: 'Editar servicio'},

          // ======= category
          { path: "categorias/lista", component: CategoryListComponent, title: 'Categorías',data: { module: "category"}},
          { path: "categorias/nuevo", component: CategoryFormComponent, data: { module: "category" }, title: 'Nueva categoría'},
          { path: "categorias/editar/:id", component: CategoryFormComponent, data: { module: "category" }, title: 'Editar categoría'},
          // ======= brand
          { path: "marcas/lista", component: BrandListComponent, title: 'Marcas', data: { module: "brand"}},
          { path: "marcas/nuevo", component: BrandFormComponent, data: { module: "brand" }, title: 'Nueva marca'},
          { path: "marcas/editar/:id", component: BrandFormComponent, data: { module: "brand" }, title: 'Editar marca'},
          // ======= line/ lineas
          { path: "lineas/lista", component: LineListComponent, title: 'Lineas', data: { module: "line"}},
          { path: "lineas/nuevo", component: LineFormComponent, data: { module: "line" }, title: 'Nueva linea'},
          { path: "lineas/editar/:id", component: LineFormComponent, data: { module: "line" }, title: 'Editar linea'},
        ]
      },
      {
        path: "almacen",
        component: WarehouseComponent,
        children: [
         // ======= entry
         { path: "entradas/lista", component: EntryListComponent, title: "Entradas", data: { module: "entry" }},
         { path: "entradas/nuevo", component: EntryFormComponent, title: "Nueva entrada", data: { module: "entry" }},
         { path: "entradas/detalle/:id", component: EntryDetailComponent, title: "Detalle entrada", data: { module: "entry" }},
         // ======= output
         { path: "salidas/lista", component: OutputListComponent, title: "Salidas", data: { module: "output" }},
         { path: "salidas/nuevo", component: OutputFormComponent, title: "Nueva salida", data: { module: "output" }},
         { path: "salidas/detalle/:id", component: OutputDetailComponent, title: "Detalle salida", data: { module: "output" }},
        
         // ======= stockgeneral
         { path: "stockgeneral/lista", component: StockgeneralListComponent, title: "Salidas", data: { module: "entry" }},
         
        ]
      },
      {
        path: "ventas",
        component: SaleComponent,
        children: [
         // ======= client
         { path: "clientes/lista", component: ClientListComponent, title: "Clientes", data: { module: "client" }},
         { path: "clientes/nuevo", component: ClientFormComponent, title: "Nueva cliente", data: { module: "client" }},
         { path: "clientes/editar/:id", component: ClientFormComponent,title: "Editar cliente",data: { module: "client" }},

          // ======= sales
          { path: "ventas/lista", component: SalesListComponent, title: "Ventas", data: { module: "sale" }},
          { path: "ventas/nuevo", component: SalesFormComponent, title: "Nueva venta", data: { module: "sale" }},
          { path: "ventas/detalle/:id", component: SalesDetailComponent,title: "Detalle venta",data: { module: "sale" }},

          // ======= proformas
          { path: "proformas/lista", component: ProformaListComponent, title: "Proformas", data: { module: "proforma" }},
          { path: "proformas/nuevo", component: ProformaFormComponent, title: "Nueva proforma", data: { module: "proforma" }},
          { path: "proformas/editar/:id", component: ProformaFormComponent,title: "Editar proforma",data: { module: "proforma" }},
          { path: "proformas/detalle/:id", component: ProformaFormComponent,title: "Detalle proforma",data: { module: "proforma" }},
        ]
      },
      {
        path: "compras",
        component: PurchaseComponent,
        children: [
         // ======= client
         { path: "proveedores/lista", component: ProviderListComponent, title: "Proveedores", data: { module: "provider" }},
         { path: "proveedores/nuevo", component: ProviderFormComponent, title: "Nueva proveedor", data: { module: "provider" }},
         { path: "proveedores/editar/:id", component: ProviderFormComponent,title: "Editar proveedor",data: { module: "provider" }},
         
        ]
      },
      {
        path: "caja",
        component: MoneyComponent,
        children: [
          // ======= opening
          { path: "apertura", component: OpeningListComponent, title: "Apertura caja", data: { module: "opening" }},
          // ======= income
          { path: "ingresos/lista", component: IncomeListComponent, title: "Ingresos", data: { module: "income" }},
          { path: "ingresos/nuevo", component: IncomeFormComponent, title: "Nuevo ingreso", data: { module: "income" }},
          { path: "ingresos/editar/:id", component: IncomeFormComponent,title: "Editar ingreso",data: { module: "income" }},
          // ======= expense
          { path: "egresos/lista", component: ExpenseListComponent, title: "Egresos", data: { module: "expense" }},
          { path: "egresos/nuevo", component: ExpenseFormComponent, title: "Nuevo egreso", data: { module: "expense" }},
          { path: "egresos/editar/:id", component: ExpenseFormComponent,title: "Editar egreso",data: { module: "expense" }},
          // ======= expense
          { path: "historialcaja/lista", component: HistoryboxListComponent, title: "Historial Caja", data: { module: "historybox" }},
          { path: "historialcaja/detalle/:id", component: HistoryboxDetailComponent, title: "Caja detalle", data: { module: "historybox" }},
        ]
      },
      {
        path: "finanzas",
        component: FinanceComponent,
        children: [
          // ======= bank
          { path: "bancos/lista", component: BankListComponent, title: "Bancos", data: { module: "bank" }},
          { path: "bancos/nuevo", component: BankFormComponent, title: "Nuevo banco", data: { module: "bank" }},
          { path: "bancos/editar/:id", component: BankFormComponent,title: "Editar banco",data: { module: "bank" }},
          // ======= accountbank
          { path: "cuentas_bancarias/lista", component: AccountbankListComponent, title: "Cuentas bancarias", data: { module: "accountbank" }},
          { path: "cuentas_bancarias/nuevo", component: AccountbankFormComponent, title: "Nuevo cuenta bancaria", data: { module: "accountbank" }},
          { path: "cuentas_bancarias/editar/:id", component: AccountbankFormComponent,title: "Editar cuenta bancaria",data: { module: "accountbank" }},
        ]
      },
      {
        path: "reservas",
        component: BookingComponent,
        children: [
          // ======= arrivals
          { path: "llegadas/lista", component: ArrivalsListComponent, title: "Llegadas", data: { module: "arrivals" }},
         // ======= bookings
         { path: "reserva/lista", component: BookingsListComponent, title: "Reservas", data: { module: "booking" }},
         { path: "reserva/nuevo", component: BookingsFormComponent, title: "Nueva reserva", data: { module: "booking" }},
         { path: "reserva/editar/:id", component: BookingsFormComponent,title: "Editar reserva",data: { module: "booking" }},
         { path: "reserva/detalle/:id", component: BookingsDetailComponent,title: "Detalle reserva",data: { module: "booking" }},
          // ======= transfers
          { path: "traspasos/lista", component: TransfersListComponent, title: "Traspasos", data: { module: "transfers" }},
          { path: "traspasos/nuevo", component: TransfersFormComponent, title: "Nueva traspaso", data: { module: "transfers" }},
          { path: "traspasos/editar/:id", component: TransfersFormComponent,title: "Editar traspaso",data: { module: "transfers" }},
          { path: "traspasos/detalle/:id", component: TransfersDetailComponent,title: "Detalle traspaso",data: { module: "transfers" }},
          // ======= receiveds
          { path: "recibidos/lista", component: ReceivedsListComponent, title: "Recibidos", data: { module: "receiveds" }},
          { path: "recibidos/nuevo", component: ReceivedsFormComponent, title: "Nueva recibido", data: { module: "receiveds" }},
          { path: "recibidos/editar/:id", component: ReceivedsFormComponent,title: "Editar recibido",data: { module: "receiveds" }},
          { path: "recibidos/detalle/:id", component: ReceivedsDetailComponent,title: "Detalle recibido",data: { module: "receiveds" }},
        ]
      },      
      {
        path: "turismo",
        component: CatalogComponent,
        children: [
          // ======= citietouristic
          { path: "ciudades/lista", component: CitietouristicListComponent, title: "Ciudades", data: { module: "citietouristic" }},
          { path: "ciudades/nuevo", component: CitietouristicFormComponent, title: "Nueva ciudad", data: { module: "citietouristic" }},
          { path: "ciudades/editar/:id", component: CitietouristicFormComponent,title: "Editar ciudad",data: { module: "citietouristic" }},
          // ======= hotel
          { path: "hoteles/lista", component: HotelListComponent, title: "Hoteles", data: { module: "hotel"}},
          { path: "hoteles/nuevo", component: HotelFormComponent, title: "Nuevo hotel", data: { module: "hotel" }},
          { path: "hoteles/editar/:id", component: HotelFormComponent,title: "Editar hotel",data: { module: "hotel"}},
          { path: "hoteles/imagenes/:id", component: HotelGalleryImgComponent,title: "Imágenes hotel",data: { module: "hotel"}},
          { path: "hoteles/videos/:id", component: HotelGalleryVideoComponent,title: "Videos hotel",data: { module: "hotel"}},
          // ======= tour
          { path: "tours/lista", component: TourListComponent, title: "Tours", data: { module: "tour" }},
          { path: "tours/nuevo", component: TourFormComponent, title: "Nuevo tour", data: { module: "tour" }},
          { path: "tours/editar/:id", component: TourFormComponent,title: "Editar tour",data: { module: "tour"}},
          { path: "tours/imagenes/:id", component: TourGalleryImgComponent,title: "Imágenes tour",data: { module: "tour"}},
          { path: "tours/videos/:id", component: TourGalleryVideoComponent,title: "Videos tour",data: { module: "tour"}},

          // ======= packagetour
          { path: "paquetes/lista", component: PackagetourListComponent, title: "Paquetes", data: { module: "packagetour"}},
          { path: "paquetes/nuevo", component: PackagetourFormComponent, title: "Nuevo paquete", data: { module: "packagetour" }},
          { path: "paquetes/editar/:id", component: PackagetourFormComponent,title: "Editar paquete",data: { module: "packagetour"}},          
          { path: "paquetes/imagenes/:id", component: PackagetourGalleryImgComponent,title: "Imágenes paquete",data: { module: "packagetour"}},
          { path: "paquetes/videos/:id", component: PackagetourGalleryVideoComponent,title: "Videos tour",data: { module: "packagetour"}},

          // ======= cotization
          { path: "cotizaciones/lista", component: CotizationListComponent, title: "Cotizaciones", data: { module: "cotization"}},
          { path: "cotizaciones/nuevo", component: CotizationFormComponent, title: "Nueva cotización", data: { module: "cotization" }},
          { path: "cotizaciones/editar/:id", component: CotizationFormComponent,title: "Editar cotización",data: { module: "cotization"}},
         
          // ======= transport
          { path: "transportes/lista", component: TransportListComponent, title: "Transportes", data: { module: "transports" }},
          { path: "transportes/nuevo", component: TransportFormComponent, title: "Nueva transporte", data: { module: "transports" }},
          { path: "transportes/editar/:id", component: TransportFormComponent,title: "Editar transporte",data: { module: "transports" }},
          // ======= guides
          { path: "guias/lista", component: GuidesListComponent, title: "Guias de viaje", data: { module: "guides" }},
          { path: "guias/nuevo", component: GuidesFormComponent, title: "Nueva guia", data: { module: "guides" }},
          { path: "guias/editar/:id", component: GuidesFormComponent,title: "Editar guia",data: { module: "guides" }},
          // ======= agencies
          { path: "agencias/lista", component: AgenciesListComponent, title: "Agencias", data: { module: "agencies" }},
          { path: "agencias/nuevo", component: AgenciesFormComponent, title: "Nueva agencia", data: { module: "agencies" }},
          { path: "agencias/editar/:id", component: AgenciesFormComponent,title: "Editar agencia",data: { module: "agencies" }},

          // ======= ofertas
          { path: "ofertas/lista", component: OfferListComponent, title: "Ofertas", data: { module: "specialoffers" }},
          { path: "ofertas/nuevo", component: OfferFormComponent, title: "Nueva oferta", data: { module: "specialoffers" }},
          { path: "ofertas/editar/:id", component: OfferFormComponent,title: "Editar oferta",data: { module: "specialoffers" }},

           // ======= airlines
           { path: "aerolineas/lista", component: OfferListComponent, title: "Aerolineas", data: { module: "airline" }},
           { path: "aerolineas/nuevo", component: OfferFormComponent, title: "Nueva aerolinea", data: { module: "airline" }},
           { path: "aerolineas/editar/:id", component: OfferFormComponent,title: "Editar aerolinea",data: { module: "airline" }},
        
        ]
      },
      {
        path: "colaborador",
        component: CollaboratorComponent,
        children: [
         // ======= collaborator
         { path: "colaboradores/lista", component: CollaboratorsListComponent, title: "Colaboradores", data: { module: "collaborator" }},
         { path: "colaboradores/nuevo", component: CollaboratorsFormComponent, title: "Nuevo colaborador", data: { module: "collaborator" }},
         { path: "colaboradores/editar/:id", component: CollaboratorsFormComponent,title: "Editar colaborador",data: { module: "collaborator" }},

         // ======= convenios / agreements
         { path: "convenios/lista", component: AgreementsListComponent, title: "Convenios", data: { module: "agreements" }},
         { path: "convenios/nuevo", component: AgreementsFormComponent, title: "Nuevo convenio", data: { module: "agreements" }},
         { path: "convenios/editar/:id", component: AgreementsFormComponent,title: "Editar convenio",data: { module: "agreements" }},

          // ======= partners
          { path: "socios/lista", component: PartnersListComponent, title: "Socios", data: { module: "partners" }},
          { path: "socios/nuevo", component: PartnersFormComponent, title: "Nuevo socio", data: { module: "partners" }},
          { path: "socios/editar/:id", component: PartnersFormComponent,title: "Editar socio",data: { module: "partners" }},
        ]
      },
      {
        path: "salidas",
        component: DepartureComponent,
        children: [
         // ======= schedule (cronograma)
         { path: "cronograma/lista", component: ScheduleListComponent, title: "Cronograma", data: { module: "schedule" }},

         // ======= schedule (cronograma)
         { path: "cronograma/reservas/abiertas", component: ScheduleOpenListComponent, title: "Cronograma Reservas Abiertas", data: { module: "schedule" }},

         // ======= grupos
         { path: "grupos/lista", component: GroupListComponent, title: "Grupos", data: { module: "groups" }},
         { path: "grupos/nuevo", component: GroupFormComponent, title: "Nuevo grupo", data: { module: "groups" }},
         { path: "grupos/editar/:id", component: GroupFormComponent,title: "Editar grupo",data: { module: "groups" }},
         { path: "grupos/detalle/:id", component: GroupDetailComponent,title: "Detalle grupo",data: { module: "groups" }},
        ]
      },

      {
        path: "facturacion",
        component: BillingComponent,
        children: [
         // ======= client
         { path: "facturas/lista", component: VoucherListComponent, title: "Facturas", data: { module: "vouchers" }},
         { path: "comprobantes/nuevo", component: VoucherFormComponent, title: "Nuevo comprobante", data: { module: "vouchers" }},
         
        ]
      },

      {
        path: "pasajes",
        component: FlightComponent,
        children: [
          // ======= vuelo
         { path: "tickets/lista", component: BookingflightsListComponent, title: "Gestion tickets", data: { module: "bookingflights" }},
         { path: "tickets/nuevo", component: BookingflightsFormComponent, title: "Nuevo ticket", data: { module: "bookingflights" }},
         { path: "tickets/editar/:id", component: BookingflightsFormComponent,title: "Editar ticket",data: { module: "bookingflights" }},
         { path: "tickets/detalle/:id", component: BookingflightsDetailComponent,title: "Detalle ticket",data: { module: "bookingflights" }},
         
          // ======= aerolineas
          { path: "aerolinea/lista", component: AirlinesListComponent, title: "Aerolineas", data: { module: "airline" }},
          { path: "aerolinea/nuevo", component: AirlinesFormComponent, title: "Nueva aerolinea", data: { module: "airline" }},
          { path: "aerolinea/editar/:id", component: AirlinesFormComponent,title: "Editar aerolinea",data: { module: "airline" }},
        ]
      },

      {
        path: "hoteleria",
        component: HospitalityComponent,
        children: [
          // ======= tipo habitaciones
          { path: "tipo_habitaciones/lista", component: RoomtypeListComponent, title: "Tipo Habitaciones", data: { module: "roomtypes" }},
          { path: "tipo_habitaciones/nuevo", component: RoomtypeFormComponent, title: "Nuevo tipo habitación", data: { module: "roomtypes" }},
          { path: "tipo_habitaciones/editar/:id", component: RoomtypeFormComponent,title: "Editar tipo habitación",data: { module: "roomtypes" }},

          // ======= habitaciones
          { path: "habitaciones/lista", component: BedroomListComponent, title: "Habitaciones", data: { module: "bedrooms" }},
          { path: "habitaciones/nuevo", component: BedroomFormComponent, title: "Nueva habitación", data: { module: "bedrooms" }},
          { path: "habitaciones/editar/:id", component: BedroomFormComponent,title: "Editar habitación",data: { module: "bedrooms" }},

          // ======= tarifas
          { path: "tarifas/lista", component: RatesListComponent, title: "Tarifas", data: { module: "rates" }},
          { path: "tarifas/nuevo", component: RatesFormComponent, title: "Nueva tarifa", data: { module: "rates" }},
          { path: "tarifas/editar/:id", component: RatesFormComponent,title: "Editar tarifa",data: { module: "rates" }},

          // ======= configurar tarifas por tipo de habtiacion
          { path: "tarifas_habitaciones/precios/:id", component: RatesPricesComponent,title: "Precios Habitaciones",data: { module: "rates" }},
        ]
      },

      {
        path: "reservashotel",
        component: HotelbookingComponent,
        children: [
          // ======= planning
          { path: "planning", component: HotelplaningComponent, title: "Hotel Planning", data: { module: "hotelplanning" }},

          // ======= reservas
          { path: "reservas/lista", component: HotelbookingsListComponent, title: "Reservas hotel", data: { module: "hotelbooking" }},
          { path: "reservas/nuevo", component: HotelbookingsFormComponent, title: "Nueva reserva hotel", data: { module: "hotelbooking" }},
          { path: "reservas/editar/:id", component: HotelbookingsFormComponent,title: "Editar reserva hotel",data: { module: "hotelbooking" }},
          { path: "reservas/detalle/:id", component: HotelbookingsDetailComponent,title: "Detalle reserva hotel",data: { module: "hotelbooking" }},

          // ======= transfers
          { path: "transfers/lista", component: HoteltransfersListComponent, title: "Transfers Reservas", data: { module: "hoteltransfers" }},
        ]
      },

      {
        path: "restaurante",
        component: RestaurantComponent,
        children: [
          // ======= categoria platos
          { path: "categoria_platos/lista", component: CategoryfoodListComponent, title: "Categoría platos", data: { module: "categoryfood" }},
          { path: "categoria_platos/nuevo", component: CategoryfoodFormComponent, title: "Nueva categoría", data: { module: "categoryfood" }},
          { path: "categoria_platos/editar/:id", component: CategoryfoodFormComponent,title: "Editar categoría",data: { module: "categoryfood" }},

          // ======= platos
          { path: "platos/lista", component: FoodsListComponent, title: "Platos", data: { module: "foods" }},
          { path: "platos/nuevo", component: FoodsFormComponent, title: "Nuevo plato", data: { module: "foods" }},
          { path: "platos/editar/:id", component: FoodsFormComponent,title: "Editar plato",data: { module: "foods" }},

          //  nuevos modulos para acceso a modulos de pedidos de restaurante

          // ======= ambientes/mesas
          { path: "ambientes_mesas/lista", component: LoungesListComponent, title: "Ambientes/Mesas", data: { module: "loungesrestaurant" }},
          { path: "ambientes_mesas/nuevo", component: LoungesFormComponent, title: "Nuevo Ambiente", data: { module: "loungesrestaurant" }},
          { path: "ambientes_mesas/editar/:id", component: LoungesFormComponent,title: "Editar Ambiente",data: { module: "loungesrestaurant" }},
          { path: "ambientes_mesas/mesas/:id", component: LoungesTablesComponent, title: "Lista mesas ambientes", data: { module: "loungesrestaurant" }},

        ]
      },

      {
        path: "blog",
        component: BlogComponent,
        children: [
          // ======= Publicaciones
          { path: "publicaciones/lista", component: PostsListComponent, title: "Publicaciones", data: { module: "posts" }},
          { path: "publicaciones/nuevo", component: PostsFormComponent, title: "Nueva publicación", data: { module: "posts" }},
          { path: "publicaciones/editar/:id", component: PostsFormComponent,title: "Editar publicación",data: { module: "posts" }},

          // ======= Categorías
          { path: "categorias/lista", component: BlogcategoryListComponent, title: "Categorías", data: { module: "blogcategories" }},
          { path: "categorias/nuevo", component: BlogcategoryFormComponent, title: "Nueva categoría", data: { module: "blogcategories" }},
          { path: "categorias/editar/:id", component: BlogcategoryFormComponent,title: "Editar categoría",data: { module: "blogcategories" }},

          // ======= Autores
          { path: "autores/lista", component: AuthorListComponent, title: "Autores", data: { module: "author" }},
          { path: "autores/nuevo", component: AuthorFormComponent, title: "Nuevo autor", data: { module: "author" }},
          { path: "autores/editar/:id", component: AuthorFormComponent,title: "Editar autor",data: { module: "author" }},
        ]
      },

      {
        path: "reportes",
        component: ReportComponent,
        children: [
         // ======= base reportes
         { path: "lista", component: ReportListComponent, title: "Reportes", data: { module: "report" }},


         // ======= bookings
         { path: "reservas/resumen_asesor", component: SummaryAdviserComponent, title: "Resumen asesor", data: { module: "report" }},


         // ======= blockshotel
         { path: "cuadreshotel/lista", component: BlockshotelComponent, title: "Cuadres Hotel", data: { module: "report" }},
         { path: "cuadreshotel/nuevo", component: BlockshotelFormComponent, title: "Nuevo cuadre hotel", data: { module: "report" }},      
         { path: "cuadreshotel/detalle/:id", component: BlockshotelDetailComponent,title: "Detalle cuadre hotel",data: { module: "report" }},

         // ======= blocksagency
         { path: "cuadresagencia/lista", component: BlocksagencyComponent, title: "Cuadres Agencia", data: { module: "report" }},
         { path: "cuadresagencia/nuevo", component: BlocksagencyFormComponent, title: "Nuevo cuadre agencia", data: { module: "report" }},      
         { path: "cuadresagencia/detalle/:id", component: BlocksagencyDetailComponent,title: "Detalle cuadre agencia",data: { module: "report" }},

         // ***** SCHEDULE
         // ======= (cronograma)
         { path: "salidas/cronograma", component: ScheduleReportComponent, title: "Reporte cronograma", data: { module: "report" }},
         // ======= (grupos)
         { path: "salidas/grupos", component: GroupReportComponent, title: "Reporte grupos", data: { module: "report" }},
         { path: "salidas/grupos/balance/:id", component: GroupReportBalanceComponent,title: "Detalle cuadre grupo",data: { module: "report" }},
         
         // ======= (guias)
         { path: "salidas/guias", component: GuideReportComponent, title: "Reporte guia", data: { module: "report" }},
         // ======= (transporte)
         { path: "salidas/transporte", component: TransportReportComponent, title: "Reporte transporte", data: { module: "report" }},


         // ***** FATURACION
         // ======= (documentos) | invoices
         { path: "facturacion/documentos", component: VouchersReportComponent, title: "Reporte comprobantes", data: { module: "report" }},        

        ]
      },
    ]
  },
  { path: '**', component: PageNotfoundComponent }

  // { path: "notas", component: NotesComponent, pathMatch: "full" },
  // {
  //   path: valSlug+"/catalogo",component: CatalogComponent,
  //   children: [
  //     { path: "productos", component: ProductListComponent , title:"Productos | Lista"},
  //     { path: "producto/:id/:name", component: ProductDetailComponent },
  //     { path: "producto/nuevo", component: ProductFormComponent },
  //     { path: "categorias", component: CategoryListComponent },
  //   ],
  // },
  // { path:'',   redirectTo: valSlug+'/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private globalService: GlobalService) {
    if (valSlug != 'slug') {
      this.globalService.slugBranchoffice = valSlug;
    }
  }
  
}
